import React from 'react';
import { LayoutGrid, Gift, GraduationCap, ChevronDown, ArrowUpDown } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';
import { LEVEL_OPTS, catIcon } from './meta';

const chip = (active) => `shrink-0 h-10 px-4 rounded-xl border text-sm font-semibold inline-flex items-center gap-2 whitespace-nowrap transition-colors ${active ? 'bg-blue-600 border-blue-600 text-white shadow-md shadow-blue-600/20' : 'bg-white border-slate-200 text-slate-700 hover:border-blue-300'}`;
const Divider = () => <span className="hidden lg:block w-px h-8 bg-slate-200 shrink-0" />;
const Label = ({ children }) => <span className="shrink-0 text-sm text-slate-500">{children}</span>;

const Select = ({ Icon, value, onChange, testId, children }) => (
  <div className="relative">
    <Icon className="absolute top-1/2 -translate-y-1/2 start-3 w-4 h-4 text-blue-600 pointer-events-none" />
    <select data-testid={testId} value={value} onChange={e => onChange(e.target.value)}
      className="appearance-none h-10 w-full sm:w-auto sm:min-w-[170px] ps-9 pe-9 rounded-xl bg-white border border-slate-200 text-sm font-semibold text-slate-800 cursor-pointer hover:border-blue-300 outline-none">
      {children}
    </select>
    <ChevronDown className="absolute top-1/2 -translate-y-1/2 end-3 w-4 h-4 text-slate-400 pointer-events-none" />
  </div>
);

export const FilterBar = ({ cats, cat, setCat, level, setLevel, freeOnly, setFreeOnly, sort, setSort, getLabel }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  return (
    <div data-testid="courses-filter-bar" className="rounded-2xl bg-white/90 border border-slate-200/80 shadow-[0_4px_20px_-10px_rgba(15,23,42,0.12)] p-3 sm:p-4 flex flex-col lg:flex-row lg:flex-wrap lg:items-center gap-3 lg:gap-4">
      <div className="flex items-center gap-2 min-w-0">
        <Label>{L('التصنيف:', 'Category:')}</Label>
        <div data-testid="courses-chips" className="flex items-center gap-2 overflow-x-auto scrollbar-none min-w-0">
          <button type="button" data-testid="course-filter-all" onClick={() => setCat('all')} className={chip(cat === 'all')}><LayoutGrid className="w-4 h-4" />{L('الكل', 'All')}</button>
          {cats.map(c => {
            const Ic = catIcon(c.value);
            const active = cat === c.value;
            return <button key={c.value} type="button" data-testid={`course-filter-${c.value}`} onClick={() => setCat(active ? 'all' : c.value)} className={chip(active)}><Ic className={`w-4 h-4 ${active ? '' : 'text-blue-600'}`} />{getLabel(c.value, lang)}</button>;
          })}
        </div>
      </div>
      <Divider />
      <div className="flex items-center gap-2">
        <Label>{L('المستوى:', 'Level:')}</Label>
        <div className="flex-1 sm:flex-none">
          <Select Icon={GraduationCap} value={level} onChange={setLevel} testId="course-level-select">
            <option value="all">{L('جميع المستويات', 'All levels')}</option>
            {LEVEL_OPTS.map(o => <option key={o.key} value={o.key}>{L(o.ar, o.en)}</option>)}
          </Select>
        </div>
      </div>
      <Divider />
      <button type="button" data-testid="course-filter-free" onClick={() => setFreeOnly(!freeOnly)}
        className={`self-start lg:self-auto h-10 px-4 rounded-xl border text-sm font-semibold inline-flex items-center gap-2 transition-colors ${freeOnly ? 'bg-emerald-500 border-emerald-500 text-white' : 'bg-emerald-50/60 border-emerald-200 text-emerald-700 hover:bg-emerald-50'}`}>
        <Gift className="w-4 h-4" />{L('مجاني فقط', 'Free only')}
      </button>
      <Divider />
      <div className="flex items-center gap-2 lg:ms-auto">
        <Label>{L('ترتيب:', 'Sort:')}</Label>
        <div className="flex-1 sm:flex-none">
          <Select Icon={ArrowUpDown} value={sort} onChange={setSort} testId="sort-select">
            <option value="latest">{L('الأحدث أولاً', 'Newest first')}</option>
            <option value="popular">{L('الأكثر طلاباً', 'Most students')}</option>
            <option value="hours_asc">{L('الأقصر مدة', 'Shortest first')}</option>
            <option value="hours_desc">{L('الأطول مدة', 'Longest first')}</option>
          </Select>
        </div>
      </div>
    </div>
  );
};
